import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ExpandIcon from '../../../images/expand.svg';
import * as Styled from './CookieConsentStyles';
import LocalStorage from '../../services/LocalStorage';
import CookieOptions from './CookieOptions';
import {EmojiWrapper} from '../EmojiWrapper';

const LOCAL_COOKIE = 'cookieConsent'

const applyAnalytics = (settings:any) => {
  const gtag = (window as any).gtag;
  if (settings.analytics) {
    gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
    // hotjar tracking code
    // @ts-ignore
    (function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:2549945,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
}
const CookieConsent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [cookieSettings, setCookieSettings] = useState({
    essential: true,
    //functional: false,
    analytics: false,
  });

  const toggleOptions = () => {
    setExpanded(!expanded);
  }

  const onSettingsChange = (type:string) => {
    setCookieSettings({
      ...cookieSettings,
      //@ts-ignore
      [type]: !cookieSettings[type],
    })
  }

  const onSaveSettings = () => {
    LocalStorage.setItem(LOCAL_COOKIE, cookieSettings);
    applyAnalytics(cookieSettings);
    setIsOpen(false);
  }

  const acceptAll = () => {
    const settings = {
      essential: true,
      //functional: true,
      analytics: true,
    }
    LocalStorage.setItem(LOCAL_COOKIE, settings);
    applyAnalytics(settings);
    setIsOpen(false);
  }

  useEffect(() => {
    const localSettings = LocalStorage.getItem(LOCAL_COOKIE);
    if (!localSettings) {
      setIsOpen(true);
      return;
    }
    setCookieSettings(localSettings);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <Styled.Wrapper>
      <Styled.H5>
        You are in control of cookies <EmojiWrapper>&#127850;</EmojiWrapper>
      </Styled.H5>
      <Styled.Content>
        We use different cookies to improve your experience on our website. These cookies enhance the performance and functionality of our website, remember your preferences, provide personalized content, and more. Because we respect your right to privacy, you can manage your options. However, some functionalities may become unavailable without these cookies. You can adjust your settings below or read more about our Cookie Policy <Link to="/privacy#information" target="_blank">here</Link>.
      </Styled.Content>
      <Styled.Actions>
        <Styled.ManageBtn onClick={toggleOptions}>
          Manage your privacy options <Styled.Icon src={ExpandIcon} className={expanded ? 'rotate' : ''} />
        </Styled.ManageBtn>
        <Styled.AcceptBtn onClick={acceptAll}>
          Accept all
        </Styled.AcceptBtn>
      </Styled.Actions>
      <CookieOptions
        isOpen={expanded}
        settings={cookieSettings}
        onChange={onSettingsChange}
        onSave={onSaveSettings}
      />
    </Styled.Wrapper>
  )
}

export default CookieConsent;